import HeaderToolbar from '../../Component/HeaderToolbar'
import React from 'react'

type RecurringBaseLayoutProps = {
  children?: React.ReactNode;
  title?: string;
  helpLink?: string;
}

export default function RecurringBaseLayout ({ children, title, helpLink }: RecurringBaseLayoutProps): React.ReactElement {
  return (
    <div className="recurring-layout-container">
      {helpLink && <HeaderToolbar helpLink={helpLink} />}

      {title && <h1 className="page-title">{title}</h1>}

      <hr className='clear' />

      <main className="layout-content">
        {children}
      </main>
    </div>
  )
}
